import React from 'react'
import PropTypes from 'prop-types'
import {
  LaunchDarklyClient,
  setFlags,
  loadFlagsSuccess,
} from 'li-feature-flags/lib'

import Application from './components/Application'
import Login from './components/Login'
import SecondFactor from './components/SecondFactor'
import VerifyEmail from './components/VerifyEmail'
import AccessRestricted from './components/AccessRestricted'
import { actions } from './lib'
import createRouteHooks from './routeHooks'
import createLogout from './logout'
import { isEmpty } from './util'
import conf from './config'

const { launchDarklyKey, featureFlags: appShellFeatureFlags } = conf

export default (store, config) => {
  const routeHooks = createRouteHooks(store, config)
  const logout = createLogout(store)

  const routes = [
    { path: 'login', component: Login, onEnter: routeHooks.root },
    { path: 'logout', onEnter: logout },
    { path: 'second-factor', component: SecondFactor },
    { path: 'verify-email(/:registrationType)', component: VerifyEmail },
    {
      path: `${config.appId}/access-restricted`,
      component: AccessRestricted,
      onEnter: routeHooks.requireAuth,
    },
  ]

  watchForFeatureFlags(store, {
    ...appShellFeatureFlags,
    ...(config.featureFlags || {}),
  })

  if (global.localStorage.getItem('li.appShell.profileChanged')) {
    showProfileChangedNotificationOnUserSuccess(store)
  }

  const Shell = ({ children }) => (
    <Application store={store} {...config}>
      {children}
    </Application>
  )

  Shell.propTypes = {
    children: PropTypes.node.isRequired,
  }

  return { routeHooks, routes, Shell }
}

export function showProfileChangedNotificationOnUserSuccess(store) {
  const unsubscribe = store.subscribe(() => {
    const {
      auth: { user },
    } = store.getState()

    if (!isEmpty(user)) {
      unsubscribe()
      global.localStorage.removeItem('li.appShell.profileChanged')
      store.dispatch(actions.authShowProfileChangedNotification())
    }
  })
}

function watchForFeatureFlags(store, flags) {
  store.dispatch(setFlags(flags))

  const unsubscribe = store.subscribe(async () => {
    const {
      auth: { user },
    } = store.getState()

    if (!isEmpty(user)) {
      unsubscribe()
      getFlags(
        new LaunchDarklyClient(launchDarklyKey, user, store),
        flags,
        featureFlags => store.dispatch(loadFlagsSuccess(featureFlags))
      )
    }
  })
}

export function getFlags(client, flags, callback) {
  const featureFlags = {}

  const promises = Object.keys(flags).map(k =>
    client
      .getFlag(k)
      .then(v => {
        featureFlags[k] = v
      })
      .catch(err => {
        console.error(`[appshell] failed to fetch ${k}:`, err)
        featureFlags[k] = flags[k]
      })
  )

  return Promise.all(promises).then(() => callback(featureFlags))
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/configure.js